"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Highcharts = __importStar(require("highcharts"));
const FilterState_1 = __importDefault(require("../components/FilterState"));
const SearchResultPageStore_1 = __importDefault(require("../states/SearchResultPageStore"));
const SearchPage_1 = __importDefault(require("../states/SearchPage"));
const SelectedFiltersStore_1 = __importDefault(require("../states/SelectedFiltersStore"));
const translate_1 = require("../helper/translate");
const Graph = ({ data, colors, startOffset = 0, chartOptions, setChartConfig }) => {
    const chartRef = (0, react_1.useRef)(null);
    const chartInstance = (0, react_1.useRef)(null);
    const generateGradientColors = (startColor, endColor, dataLength) => {
        const startRGB = hexToRgb(startColor);
        const endRGB = hexToRgb(endColor);
        const colorGradient = [];
        for (let i = 0; i < dataLength; i++) {
            const ratio = i / (dataLength - 1);
            const r = Math.round(startRGB.r + ratio * (endRGB.r - startRGB.r));
            const g = Math.round(startRGB.g + ratio * (endRGB.g - startRGB.g));
            const b = Math.round(startRGB.b + ratio * (endRGB.b - startRGB.b));
            colorGradient.push(`rgb(${r}, ${g}, ${b})`);
        }
        return colorGradient;
    };
    const hexToRgb = (hex) => {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return { r, g, b };
    };
    const memoizedChartOptions = (0, react_1.useMemo)(() => ({
        chart: {
            type: "column",
            width: chartOptions.width,
            height: chartOptions.height,
            zoomType: 'x', // Enable zooming to help manage large datasets
        },
        title: {
            text: "",
        },
        xAxis: {
            type: "category",
            labels: {
                autoRotation: [-45, -90],
                style: {
                    fontSize: "13px",
                    fontFamily: "Verdana, sans-serif",
                },
            },
        },
        yAxis: {
            min: +startOffset,
        },
        legend: {
            enabled: false,
        },
        tooltip: {
            pointFormat: "{point.name}: <b>{point.fractionString}</b>",
        },
        plotOptions: {
            series: {
                turboThreshold: 5000, // Optimize for large datasets
                dataGrouping: {
                    enabled: true,
                    approximation: 'average',
                    groupPixelWidth: 10
                },
                animation: false, // Disable animations for performance
            },
            column: {
                pointWidth: chartOptions.barWidth,
                pointPadding: chartOptions.barSpacing,
                groupPadding: chartOptions.barSpacing,
            }
        },
        series: [
            {
                type: "column",
                name: "Population",
                colors: colors.length >= 2
                    ? generateGradientColors(colors[0], colors[1], data.length)
                    : ["#9b20d9", "#00f194"],
                colorByPoint: true,
                data: data,
                dataLabels: {
                    enabled: true,
                    rotation: -90,
                    color: "#FFFFFF",
                    inside: true,
                    verticalAlign: "top",
                    format: "{point.fractionString}",
                    y: 10,
                    style: {
                        fontSize: "13px",
                        fontFamily: "Verdana, sans-serif",
                    },
                },
            },
        ],
    }), [data, colors, chartOptions, startOffset]);
    (0, react_1.useEffect)(() => {
        if (chartRef.current) {
            chartInstance.current = Highcharts.chart(chartRef.current, memoizedChartOptions);
            // Directly retrieve values from memoizedChartOptions
            const { pointWidth, pointPadding, groupPadding } = memoizedChartOptions.plotOptions.column;
            setChartConfig((prevConfig) => (Object.assign(Object.assign({}, prevConfig), { width: chartInstance.current.chartWidth, height: chartInstance.current.chartHeight, barWidth: pointWidth, barSpacing: pointPadding || groupPadding })));
        }
    }, [memoizedChartOptions, setChartConfig]);
    if (!data.length || (data.length && data.every(({ y }) => isNaN(y)))) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [SearchResultPageStore_1.default.showSummary ? (SearchResultPageStore_1.default.showSummary &&
                (Object.keys(SearchResultPageStore_1.default.summaryFilters).length > 0 ? ((0, jsx_runtime_1.jsx)(FilterState_1.default, { selectedFilters: SearchResultPageStore_1.default.summaryFilters, filters: SearchPage_1.default.filters })) : ((0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: {
                        __html: `<span style="color: blue;">${(0, translate_1.translate)("Search filters")}: </span> ${(0, translate_1.translate)("None")}`,
                    } })))) : ((0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: {
                    __html: `<span style="color: blue;">${(0, translate_1.translate)("Search filters")}: </span> ${(0, translate_1.translate)("None")}`,
                } })), (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: {
                    __html: SelectedFiltersStore_1.default.statisticsResult,
                } }), (0, jsx_runtime_1.jsx)("div", { ref: chartRef })] }));
};
exports.default = Graph;
